import { Icono } from '../../../componentes/Icono';
import { diaLargo, diasEntre, sumarDias } from '../fechas';

/**
 * RV Navegador del día (8.1): ‹ fecha › con «Hoy» delante si es hoy; la fecha abre el calendario del sistema (un campo de
 * fecha encima, transparente).
 */
export function NavegadorDia({ valor, hoy, movil, onCambio }: { valor: string; hoy: string; movil: boolean; onCambio: (dia: string) => void }) {
    const n = diasEntre(valor, hoy);
    const delante = n === 0 ? 'Hoy' : n === -1 ? 'Ayer' : n === 1 ? 'Mañana' : null;
    return (
        <div className={`rv-rs-nav${movil ? ' rv-rs-nav--movil' : ''}`} role="group" aria-label="Día de las reservas">
            <button type="button" className="rv-bi rv-rs-nav__flecha" aria-label="Día anterior" onClick={() => { onCambio(sumarDias(valor, -1)); }}>
                <Icono nombre="chevron-left" />
            </button>
            <label className="rv-rs-nav__fecha">
                <Icono nombre="calendar" />
                <span>
                    {delante !== null && <b className="rv-rs-nav__hoy">{delante}</b>}
                    {delante !== null && <span className="rv-rs-nav__punto"> • </span>}
                    <strong>{diaLargo(valor)}</strong>
                </span>
                <Icono nombre="chevron-down" />
                <input
                    type="date"
                    aria-label="Elegir el día"
                    value={valor}
                    onChange={(e) => {
                        if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                            onCambio(e.target.value);
                        }
                    }}
                />
            </label>
            <button type="button" className="rv-bi rv-rs-nav__flecha" aria-label="Día siguiente" onClick={() => { onCambio(sumarDias(valor, 1)); }}>
                <Icono nombre="chevron-right" />
            </button>
        </div>
    );
}
